/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInput/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function TysiaInput({
  children,
  viewPath = "/DesignSystem/TysiaInput",
  flexGrow = 1,
  flexBasis,
  marginTop,
  marginRight = 0,
  marginBottom = 0,
  marginLeft = 0,
  maxWidth,
  width = "100%",
  onMouseEnter,
  onMouseLeave,
  disabled,
  type,
  placeholder,
  size,
  dock,
  focused,
  hovered,
  invalid,
  valid,
  required,
  value,
  min,
  max,
  step,
  autoFocus,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  disableFuture,
  dateFuture,
  disablePast,
  datePast,
  yearPicker,
  onKeyUp
  
}) {
  let isMedia = useIsMedia()
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let marginTopOrdtSpaceM = marginTop ?? dtSpaceM
let marginTopOrdtSpaceXs = marginTop ?? dtSpaceXs
  return (<React.Fragment
>
<div
  data-testid="TysiaInput.Vertical"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--fg-1-1jTofS': flexGrow,'--fb-2-1jTofS': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis,'--mr-4-1jTofS': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-5-1jTofS': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-6-1jTofS': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mw-7-1jTofS': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--w-8-1jTofS': typeof width === 'number' ? `${width}px` : width,'--c-9-1jTofS': disabled ? "default" : "auto",'--mt-3-1jTofS': isMedia.mobile ? typeof marginTopOrdtSpaceXs === 'number' ? `${marginTopOrdtSpaceXs}px` : marginTopOrdtSpaceXs : typeof marginTopOrdtSpaceM === 'number' ? `${marginTopOrdtSpaceM}px` : marginTopOrdtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 type={type}
 placeholder={placeholder}
 size={size}
 dock={dock}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 required={required}
 value={value}
 min={min}
 max={max}
 step={step}
 autoFocus={autoFocus}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 disableFuture={disableFuture}
 dateFuture={dateFuture}
 disablePast={disablePast}
 datePast={datePast}
 yearPicker={yearPicker}
 onKeyUp={onKeyUp}
>
{children}
</Children>
</div>
</React.Fragment>)
}